import { useSyncExternalStore } from "react";

export const REQUESTS_LEFT_HEADER = "X-Requests-Left";
export const REQUESTS_LEFT_WARNING_THRESHOLD = 10;

export class ChatLimitReachedError extends Error {
  constructor() {
    super("Monthly chat requests limit reached");
    this.name = "ChatLimitReachedError";
  }
}

let requestsLeft: number | null = null;
const listeners = new Set<() => void>();

export const setChatRequestsLeft = (value: number | null) => {
  if (value === requestsLeft) return;
  requestsLeft = value;
  listeners.forEach((listener) => listener());
};

export const updateChatRequestsLeftFromResponse = (response: Response) => {
  const parsed = parseInt(response.headers.get(REQUESTS_LEFT_HEADER) ?? "", 10);
  if (!Number.isNaN(parsed)) setChatRequestsLeft(parsed);
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useChatRequestsLeft = () =>
  useSyncExternalStore(subscribe, () => requestsLeft);
